export default "/images/vendor/flag-icons/flags/1x1/bg.svg?0717abbc6df210a43c5d26cd34be00c4";